var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInfos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_87",
    "data-name": "Groupe 87",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.009,
    height: 34.009,
    viewBox: "0 0 34.009 34.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    fill: "black",
    id: "Trac\\xE9_168",
    "data-name": "Trac\\xE9 168",
    d: "M17,31.883A14.879,14.879,0,1,1,31.883,17,14.879,14.879,0,0,1,17,31.883Zm0,2.126A17,17,0,1,0,0,17,17,17,0,0,0,17,34.009Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    fill: "black",
    id: "Trac\\xE9_169",
    "data-name": "Trac\\xE9 169",
    d: "M11.239,9.581l-4.466.565-.16.748.878.163c.573.138.687.347.562.924L6.613,18.811c-.378,1.766.2,2.6,1.576,2.6a4.02,4.02,0,0,0,2.857-1.178l.172-.819A2.148,2.148,0,0,1,9.88,19.9c-.536,0-.731-.38-.593-1.05Zm.137-4.112A1.95,1.95,0,1,1,9.426,3.5,1.96,1.96,0,0,1,11.376,5.469Z",
    transform: "translate(8.066 4.55)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfos);
export default __webpack_public_path__ + "static/media/icon-infos.ddbc9026b2b5445b44dbaeb4e7a435d6.svg";
export { ForwardRef as ReactComponent };